/* eslint-disable react/no-array-index-key -- TODO: LLM-generated items have no stable IDs */
import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import Chip from '@zenbusiness/zui/Chip';

/**
 * Renders a list of availability items as chips
 * @param {object} props - Component props
 * @param {Array<{label: string, available: boolean}>} props.items - Array of availability items
 * @returns {import('react').ReactElement} The availability list component
 */
function AvailabilityList({ items }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {}
      {}
      {items?.map((item, index) => (
        <Chip
          key={`${item.label}-${index}`}
          color={item.available ? 'success' : 'default'}
          label={
            <span>
              <strong>{item.label}</strong> {item.available ? 'Available' : 'Taken'}
            </span>
          }
          size="small"
          variant={item.available ? 'contained' : 'outlined'}
        />
      ))}
    </Box>
  );
}

AvailabilityList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      available: PropTypes.bool.isRequired
    })
  ).isRequired
};

export default AvailabilityList;
